import {map} from 'lodash-es';
import {all, spawn} from 'redux-saga/effects';

import {watchInitializeAssignmentReview} from 'modulesV2/sagas/canvasAssignmentReviewSagas';
import {watchFetchCollectionsRequest} from 'modulesV2/sagas/collectionsSagas';
import {watchGetContent} from 'modulesV2/sagas/contentSagas';
import {watchFetchEmails, watchMakeEmailPrimary, watchCreateNewEmail} from 'modulesV2/sagas/emailsSagas';
import {watchFetchEventRecords, watchCreateEventRecord} from 'modulesV2/sagas/eventRecordSagas';
import {watchClearExternalToolContext, watchSetExternalToolContext, watchGetExternalToolContext} from 'modulesV2/sagas/externalToolSagas';
import {watchGetLessonSpark} from 'modulesV2/sagas/lessonSparksSagas';
import {watchGetLikedContent, watchCreateLikedContent, watchDeleteLikedContent} from 'modulesV2/sagas/likedContentSagas';
import {watchInitializeYourContentPage, watchBookmarkedArticleHeadersFetchRequest, watchTextSetsFetchRequest, watchBookmarkedStandardsFetchRequest} from 'modulesV2/sagas/yourContentPageSagas';

import {watchGetArticleHeaderClassrooms} from '../modules/sagas/articleHeaderClassroomSagas';
import {watchGetArticleHeader} from '../modules/sagas/articleHeaderSagas';
import {watchGetArticleWords} from '../modules/sagas/articleWordSagas';
import {watchGetAssignmentsV3, watchStartAssignmentsPolling} from '../modules/sagas/assignmentSagas';
import {watchGetClassrooms, watchCreateClassroom, watchStartClassroomPolling} from '../modules/sagas/classroomSagas';
import {watchGetContentHides, watchToggleContentHide} from '../modules/sagas/contentHideSagas';
import {watchGetContentRow} from '../modules/sagas/contentRowSagas';
import {watchGetModelsByPrimaryKeys} from '../modules/sagas/genericModelSagas';
import {watchGetLicenses} from '../modules/sagas/licenseSagas';
import {watchPollForNotifications, watchInitNotifications} from '../modules/sagas/notificationsSagas';
import {watchGetSearch} from '../modules/sagas/searchSagas';
import {watchRequestUserSignOut} from '../modules/sagas/sessionSagas';
import {watchGetStudentAssignmentViews} from '../modules/sagas/studentAssignmentViewSagas';
import {watchGetStudentQuizzes} from '../modules/sagas/studentQuizSagas';
import {watchPersistTextSet, watchAddHeaderToTextSet, watchRemoveHeaderFromTextSet, watchGetTextSet} from '../modules/sagas/textSetSagas';
import {watchGetUserExperimentSegments} from '../modules/sagas/userExperimentSegmentsSagas';
import {watchGetCurrentUser, watchCreateNewUser, watchRefreshCurrentUser} from '../modules/sagas/userSagas';
import binderRouteSagas from '../routes/Binder/modules/sagas';
import readRouteSagas from '../routes/Read/modules/sagas';
import signUpSagas from '../routes/SignUp/modules/sagas';
import studentBinderRouteSagas from '../routes/StudentBinder/modules/sagas';

// The root saga is responsible for starting all the sagas in the app.
function * rootSaga() {
  const sagas = [
    ...binderRouteSagas,
    ...readRouteSagas,
    ...studentBinderRouteSagas,
    ...signUpSagas,
    watchPollForNotifications,
    watchAddHeaderToTextSet,
    watchCreateClassroom,
    watchGetArticleHeader,
    watchGetArticleWords,
    watchGetArticleHeaderClassrooms,
    watchGetAssignmentsV3,
    watchStartAssignmentsPolling,
    watchGetClassrooms,
    watchGetContentHides,
    watchGetContentRow,
    watchCreateNewUser,
    watchGetCurrentUser,
    watchGetModelsByPrimaryKeys,
    watchGetStudentQuizzes,
    watchGetSearch,
    watchGetTextSet,
    watchGetUserExperimentSegments,
    watchInitNotifications,
    watchPersistTextSet,
    watchRefreshCurrentUser,
    watchRequestUserSignOut,
    watchRemoveHeaderFromTextSet,
    watchStartClassroomPolling,
    watchToggleContentHide,
    watchGetStudentAssignmentViews,
    watchGetLicenses,
    watchFetchEmails,
    watchMakeEmailPrimary,
    watchCreateNewEmail,
    watchGetContent,
    watchGetLikedContent,
    watchCreateLikedContent,
    watchDeleteLikedContent,
    watchGetLessonSpark,
    watchClearExternalToolContext,
    watchSetExternalToolContext,
    watchGetExternalToolContext,
    watchInitializeAssignmentReview,
    watchFetchEventRecords,
    watchCreateEventRecord,
    watchFetchCollectionsRequest,
    watchInitializeYourContentPage,
    watchBookmarkedArticleHeadersFetchRequest,
    watchTextSetsFetchRequest,
    watchBookmarkedStandardsFetchRequest,
  ];

  // Run all sagas in parallel and detached from the root saga.
  // An exception in one saga should not bubble up and abort the root saga.
  const detachedTasks = map(sagas, (saga) => spawn(saga));
  yield all(detachedTasks);
}

export default rootSaga;
